var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.path == '/employer-advisor/employers/' + _vm.routeParams)?_c('Home',{staticClass:"mt-5"}):_vm._e(),_c('EmployerTemplate'),_c('Member'),_c('PriorAuths'),_c('Providers'),_c('Advisors'),_c('Bundles'),_c('Networks'),_c('Contracts'),_c('Settings')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }